import React from 'react';
import SvgPv from './SvgPv';
import SvgPVInverter from './PVInverter';
import SvgInverters from './SvgInverters';
import SvgLoad from './SvgLoad';
import SvgGridLoad from './SvgGridLoad';
import SvgHLine from './SvgHLine';
import SvgVLine from './SvgVLine';

function signed32(v) {
    if (v == null || v === '') return 0;
    let n = parseInt(v);
    if (isNaN(n)) return 0;
    if (n > 0x7fffffff) {
        n = n - 0x100000000;
    }
    return n;
}

function SvgGroupPvAndInvertersAndLoad({ SN, x, y, width, height, Combinations, onGotoIvnerterList }) {
    let slaveAs = [];
    let slaveBs = [];
    let slaveCs = [];
    let slaveGs = [];
    let flowingFromPv = false;
    let flowingToInv = false;
    let flowingFromInv = false;
    let flowingToGrid = false;
    let flowingFromGrid = false;
    let flowingToLoad = false;
    let flowingFromPvInv = false;
    let flowingToGridLoad = false;
    let invRowsCount = 0;
    let invColumnsCount = 0;
    let svg_invs_y = 0;
    let svg_invs_y2 = 0;
    let svg_invs_x2 = 0;

    if (Combinations != null) {
        Combinations.forEach((item) => {
            let mode = item.InverterConnectionMode ?? 1;
            if (mode == 1 || mode == 0) {
                slaveGs.push(item);
            } else if (mode == 2) {
                slaveAs.push(item);
            } else if (mode == 3) {
                slaveBs.push(item);
            } else if (mode == 4) {
                slaveCs.push(item);
            }

            if (item.PPV1 != null && item.PPV1 > 0) {
                flowingFromPv = true;
            }
            if (item.PPV2 != null && item.PPV2 > 0) {
                flowingFromPv = true;
            }
            if (item.PAC1Load != null && item.PAC1Load > 0) {
                flowingToLoad = true;
            }

            let pacGrid = signed32(item.PAC1Grid);
            if (item.PAC1Grid != null) {
                if (pacGrid < 0) {
                    flowingFromInv = true;
                    flowingFromGrid = true;
                } else if (pacGrid > 0) {
                    flowingToInv = true;
                    let trueFeedIn = pacGrid + signed32(item.PAC1Inverter) - signed32(item.PAC1GridLoad);
                    if (trueFeedIn > 0) {
                        flowingToGrid = true;
                    }
                }
            }

            if (item.PPVInverter != null && signed32(item.PPVInverter) > 0) {
                flowingFromPvInv = true;
            }
            if (item.PAC1GridLoad != null && signed32(item.PAC1GridLoad) > 0) {
                flowingToGridLoad = true;
            }
        });
    }
    if (slaveGs.length > 0) {
        if (slaveAs.length > 0) {
            slaveGs.push(...slaveAs);
        }
        if (slaveBs.length > 0) {
            slaveGs.push(...slaveBs);
        }
        if (slaveCs.length > 0) {
            slaveGs.push(...slaveCs);
        }
        invRowsCount = Math.ceil(slaveGs.length / 3);
        invColumnsCount = invRowsCount > 1 ? 3 : slaveGs.length;
    } else {
        let rs = Math.ceil(slaveAs.length / 3);
        let cs = rs > 1 ? 3 : slaveAs.length;
        invRowsCount = rs;
        invColumnsCount = cs;
        rs = Math.ceil(slaveBs.length / 3);
        cs = rs > 1 ? 3 : slaveBs.length;
        invRowsCount += rs;
        invColumnsCount = Math.max(invColumnsCount, cs);
        rs = Math.ceil(slaveCs.length / 3);
        cs = rs > 1 ? 3 : slaveCs.length;
        invRowsCount += rs;
        invColumnsCount = Math.max(invColumnsCount, cs);
    }

    if (invColumnsCount+invRowsCount > 2) {
        svg_invs_x2 = (110 + 15) * invColumnsCount - 15 + 10*2;
        svg_invs_y = (height - (70 + 20) * invRowsCount + 20) / 2;
        svg_invs_y2 = (height + (70 + 20) * invRowsCount - 20)/2 + 10*2;
    } else {
        svg_invs_x2 = 110;
        svg_invs_y = (height - 70) / 2;
        svg_invs_y2 = (height + 70) / 2;
    }
    if (invRowsCount >= 3) {
        let y2 = (height + (70 + 20) * 3 - 20) / 2;
        let y1 = (height - (70 + 20) * 3 + 20) / 2;
        svg_invs_x2 = svg_invs_x2 / (svg_invs_y2 - svg_invs_y) * (y2 - y1);
        svg_invs_y = y1;
        svg_invs_y2 = y2;
    }

    const iconSize = 64;
    const rightIconX = width - iconSize - 100;
    const rightIconYTop = 100;
    const rightIconYBottom = height - iconSize - 100;
    const busX = rightIconX + iconSize / 2;
    const busY = height / 2;

    return (<svg x={x} y={y} width={width} height={height}>
        <SvgPv x={18} y={15} Combinations={Combinations}/>
        <SvgPVInverter x={rightIconX} y={rightIconYTop} Combinations={Combinations}/>

        <SvgInverters x={0} y={svg_invs_y} width={svg_invs_x2} height={svg_invs_y2 - svg_invs_y} invColumnsCount={invColumnsCount} invRowsCount={invRowsCount} slaveAs={slaveAs} slaveBs={slaveBs} slaveCs={slaveCs} slaveGs={slaveGs} onGotoIvnerterList={onGotoIvnerterList}/>
        <SvgLoad x={11} y={height - 84 - 15} Combinations={Combinations}/>
        <SvgGridLoad x={rightIconX} y={rightIconYBottom} Combinations={Combinations}/>

        {/* <path d={`M${busX} ${rightIconYTop + iconSize} L${busX} ${rightIconYBottom}`} fill="none" stroke="lightgray" strokeWidth="3" strokeLinecap="round" />
        <path d={`M${svg_invs_x2} ${busY} L${width - 3} ${busY}`} fill="none" stroke="lightgray" strokeWidth="3" strokeLinecap="round" /> */}

        {flowingFromPv && <SvgVLine id={SN+"flowingFromPv"} x={13 + (84 - 6) / 2} y={15 + 84} y2={svg_invs_y} />}
        {flowingToLoad && <SvgVLine id={SN+"flowingToLoad"} x={13 + (84 - 6) / 2} y={svg_invs_y2} y2={height - 84 - 15} />}
        {flowingToInv && <SvgHLine id={SN+"flowingToInv"} x={svg_invs_x2} y={busY} x2={busX} />}
        {flowingFromInv && <SvgHLine id={SN+"flowingFromInv"} x={busX} y={busY} x2={svg_invs_x2} />}
        {flowingToGrid && <SvgHLine id={SN+"flowingToGrid"} x={busX} y={busY} x2={width - 3} />}
        {flowingFromGrid && <SvgHLine id={SN+"flowingFromGrid"} x={width - 3} y={busY} x2={busX} />}
        {flowingFromPvInv && <SvgVLine id={SN+"flowingFromPvInv"} x={busX} y={rightIconYTop + iconSize} y2={busY} />}
        {flowingToGridLoad && <SvgVLine id={SN+"flowingToGridLoad"} x={busX} y={busY} y2={rightIconYBottom} />}
    </svg>)
}

export default SvgGroupPvAndInvertersAndLoad;
